import { render, staticRenderFns } from "./ghUpload.vue?vue&type=template&id=05cafd72&scoped=true&"
import script from "./ghUpload.vue?vue&type=script&lang=js&"
export * from "./ghUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cafd72",
  null
  
)

export default component.exports